import { OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { mergeMap, finalize } from 'rxjs/operators';
import { AddressService } from '../../services/address/address.service';
import { AuthService } from '../../services/auth/auth.service';
import { Severity } from '../../services/flash-messages/flash-message.model';
import { FlashMessagesService } from '../../services/flash-messages/flash-messages.service';
import { SearchService } from '../../services/search/search.service';
import { SitesService } from '../../services/sites/sites.service';
import { ReturnUrlService } from '../../services/return-url/return-url.service';
import { WindowService } from '../../services/window/window.service';
var placeHolderText = {
    "default": "3 Grant St, Cleveland QLD 4163, Australia",
    "yarra ranges": "2442-2444 Warburton Hwy, Yarra Junction VIC 3797, Australia"
};
var AddressSearchComponent = /** @class */ (function () {
    function AddressSearchComponent(activatedRoute, authService, flashMessagesService, returnUrlService, searchService, sitesService, mappingService, router, windowService) {
        var _this = this;
        this.authService = authService;
        this.flashMessagesService = flashMessagesService;
        this.returnUrlService = returnUrlService;
        this.searchService = searchService;
        this.mappingService = mappingService;
        this.router = router;
        this.windowService = windowService;
        this.messageIds = {
            httpError: null
        };
        this.dataSource = new Observable(function (observer) {
            // Runs on every search.
            if (_this.address && _this.searchService.site) {
                _this.typeaheadNoResults = false;
                _this.typeaheadLoading = true;
                observer.next(_this.address);
            }
        }).pipe(mergeMap(function (text) {
            return _this.mappingService.findSuggestions(text, _this.searchService.site.siteNumber).pipe(finalize(function () {
                _this.typeaheadLoading = false;
            }));
        }));
        activatedRoute.params.subscribe(function (params) {
            var siteParam = params['site'];
            if (siteParam) {
                sitesService.get(siteParam).subscribe(function (result) {
                    _this.searchService.site = result;
                    _this.searchQueryParamsAddress();
                }, function (error) {
                    _this.messageIds.httpError = flashMessagesService.addMessageFor(error);
                });
            }
            else {
                _this.searchQueryParamsAddress();
            }
        });
        activatedRoute.queryParams.subscribe(function (params) {
            var add = params['address'];
            if (add && add !== _this.address) {
                _this.address = add;
                _this.searchQueryParamsAddress();
            }
        });
        this.returnUrlService.save();
    }
    Object.defineProperty(AddressSearchComponent.prototype, "canSearch", {
        get: function () {
            return !this.selectSiteEnabled || this.searchService.site !== null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AddressSearchComponent.prototype, "selectSiteEnabled", {
        get: function () {
            return this.authService.userInfo.isInRole('jjr');
        },
        enumerable: true,
        configurable: true
    });
    AddressSearchComponent.prototype.getPlaceHolderText = function () {
        var placeHolderTextName = (this.authService.userInfo.isInRole('council') ? this.authService.userInfo.councilName : 'default').toLowerCase();
        return "Address e.g. " + placeHolderText[placeHolderTextName];
    };
    AddressSearchComponent.prototype.ngOnDestroy = function () {
        this.searchService.clearAll();
    };
    AddressSearchComponent.prototype.onTypeaheadLoading = function () {
        // Clear the 'no typeahead results' (and all warnings) as soon as the user changes the input.
        this.typeaheadNoResults = false;
        this.clearWarnings();
        this.searchService.clearWarnings();
    };
    AddressSearchComponent.prototype.onTypeaheadNoResults = function (noResults) {
        this.typeaheadNoResults = noResults;
    };
    AddressSearchComponent.prototype.onTypeaheadValueSelected = function (match) {
        this.setAddressLatitudeLongitude(match.item.address, match.item.latitude, match.item.longitude);
    };
    AddressSearchComponent.prototype.clearAddress = function () {
        this.address = null;
    };
    AddressSearchComponent.prototype.search = function () {
        var _this = this;
        this.windowService.localStorage.setItem('addressSearchValue', this.address);
        var commands = ['address-search'];
        // Include the 'site' in the URL if it's defined.
        if (this.searchService.site) {
            commands.push(this.searchService.site.siteNumber);
        }
        var extras = { queryParams: {} };
        // Include the 'address' in the URL if it's defined.
        if (this.address) {
            extras.queryParams.address = this.address;
        }
        this.savedAddress = this.windowService.localStorage.getItem('addressSearchValue');
        // noinspection JSIgnoredPromiseFromCall
        this.router.navigate(commands, extras).then(function (success) {
            _this.searchService.search(_this.savedAddress, 0, 0);
            _this.address = _this.searchService.address;
            _this.returnUrlService.save();
        });
    };
    AddressSearchComponent.prototype.selectSite = function (site) {
        this.searchService.selectSite(site);
        this.address = null;
    };
    AddressSearchComponent.prototype.validateAddress = function () {
        // Only allow latitude/longitude from typeahead-selected suggestions.
        if (!this.address || this.address !== this.lastSelection) {
            this.searchService.latitude = null;
            this.searchService.longitude = null;
            this.searchService.clearResults();
        }
    };
    AddressSearchComponent.prototype.clearWarnings = function () {
        this.flashMessagesService.clear(this.multipleHighAccuracyResultsMessageId);
        this.flashMessagesService.clear(this.noHighAccuracyResultsMessageId);
        this.searchService.clearWarnings();
    };
    AddressSearchComponent.prototype.searchFromLocations = function (locations) {
        var highAccuracyLocations = locations.filter(function (location) { return location.confidence === 'High'; });
        if (highAccuracyLocations.length === 0) {
            this.typeaheadNoResults = true;
            this.noHighAccuracyResultsMessageId = this.flashMessagesService.addMessage(Severity.Warning, "Unable to accurately determine the GPS location of: " + this.address + ".");
        }
        else {
            if (highAccuracyLocations.length > 1) {
                this.multipleHighAccuracyResultsMessageId = this.flashMessagesService.addMessage(Severity.Warning, "Multiple locations found for: " + this.address + ". Selecting the first one.");
            }
            var location_1 = highAccuracyLocations[0];
            this.setAddressLatitudeLongitude(location_1.address, location_1.latitude, location_1.longitude);
            this.searchService.search(this.savedAddress, 0, 0);
        }
    };
    AddressSearchComponent.prototype.searchQueryParamsAddress = function () {
        var _this = this;
        if (this.address &&
            this.lastSelection &&
            this.searchService.latitude &&
            this.searchService.longitude &&
            this.address === this.lastSelection) {
            // If we already have all the data we need to search GPS_LOG.
            this.searchService.search(this.savedAddress, 0, 0);
        }
        else if (this.address && this.searchService.site) {
            this.typeaheadLoading = true;
            // If we have an address and site (e.g. from the query params) but haven't worked out the lat/long yet.
            this.mappingService.findSuggestions(this.address, this.searchService.site.siteNumber).subscribe(function (l) {
                _this.typeaheadLoading = false;
                _this.searchFromLocations(l);
            });
        }
    };
    AddressSearchComponent.prototype.setAddressLatitudeLongitude = function (address, latitude, longitude) {
        this.address = address;
        this.lastSelection = address;
        this.searchService.latitude = latitude;
        this.searchService.longitude = longitude;
    };
    return AddressSearchComponent;
}());
export { AddressSearchComponent };
